<template>
  <div v-if="isBookable" class="map-action">
    <template v-if="!isDated">
      <template v-if="availableToSearch">
        <pu-campsite-link
          v-if="$isDesktop"
          :hierarchy-path="hierarchyPath"
          :slug="slug"
          exclude-type="fullMinusType"
          hash="pitch-types"
        >
          <translate>Check availability</translate>
        </pu-campsite-link>
        <pu-campsite-availability-link
          v-else
          :hierarchy-path="hierarchyPath"
          :slug="slug"
          exclude-type="fullMinusType"
        >
          <img
            loading="lazy"
            src="@/assets/images/calendar.svg"
            width="21"
            height="21"
          />
          <translate>Check availability</translate>
        </pu-campsite-availability-link>
      </template>
      <template v-else>
        <translate class="zero-availability-msg">
          No availability at present on Pitchup.com
        </translate>
      </template>
    </template>

    <template v-if="isDated">
      <pu-campsite-link
        v-if="hasAvailability"
        :hierarchy-path="hierarchyPath"
        :slug="slug"
        exclude-type="fullMinusType"
        hash="pitch-types"
      >
        <translate>Book now</translate>
      </pu-campsite-link>
      <pu-campsite-availability-link
        v-else-if="!hasAvailability && availableToSearch"
        :hierarchy-path="hierarchyPath"
        :slug="slug"
        exclude-type="fullMinusType"
      >
        <img
          loading="lazy"
          src="@/assets/images/calendar.svg"
          width="21"
          height="21"
        />
        <translate>Edit search</translate>
      </pu-campsite-availability-link>
      <template v-else-if="!availableToSearch">
        <translate class="zero-availability-msg">
          No availability at present on Pitchup.com
        </translate>
      </template>
    </template>
  </div>
  <translate v-else tag="div" class="help-text">
    This site does not currently take bookings here on Pitchup.com.
  </translate>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({ emits: ['click'] })
class CampsiteMapCardButton extends Vue {
  @Prop({ required: true, type: String })
  hierarchyPath: string

  @Prop({ required: true, type: String })
  slug: string

  @Prop({ default: false, type: Boolean })
  isDated: boolean

  @Prop({ required: true, type: Boolean })
  isBookable: boolean

  @Prop({ required: false, default: true, type: Boolean })
  hasAvailability: boolean

  @Prop({ default: true, type: Boolean })
  availableToSearch: boolean
}

export default toNative(CampsiteMapCardButton)
</script>

<style scoped>
.map-action {
  align-items: center;
  background: transparent;
  border-radius: 0;
  border: none;
  box-shadow: none;
  color: var(--colour-dark-green);
  display: flex;
  flex-grow: 1;
  justify-content: center;
}

.map-action img {
  height: 1.25em;
  margin-right: 0.35em;
  opacity: 0.5;
  vertical-align: middle;
  width: auto;
}

.map-action a {
  color: var(--colour-dark-green);
  padding: 0.65em;
  text-align: center;
  text-decoration: none;
  width: 100%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-action a:active {
  background: #eef0f4;
}

.help-text {
  padding: 0.5em 1em;
  text-align: center;
  font-size: var(--small);
  color: var(--colour-text-default);
}

.zero-availability-msg {
  padding: 0.7em 1.3em;
  color: var(--colour-dark-blue);
  font-weight: bold;
  line-height: 1.2;
  font-size: var(--body);
  display: block;
}
</style>
